import React, { FC } from 'react';
import cn from 'classnames';
import { createContext } from 'react';
import { canUseDOM } from './canUseDOM';
import { presets } from './presets';
import { theme as internalTheme } from './presets/internal';
import { theme as externalTheme } from './presets/external';
export { internalTheme, externalTheme };
let prevClassName = '';
export const configureRootTheme = ({
  theme,
  root = canUseDOM() ? document.body : null
}) => {
  if (!canUseDOM) {
    return;
  }
  if (!root) {
    throw new Error('Значение в root не является DOM-элементом, невозможно установить глобальную тему.');
  }
  const rootClassName = root.className.replace(prevClassName, '');
  prevClassName = cn(`Theme_color_${theme.color}`, `Theme_root_${theme.root}`);
  root.className = rootClassName ? `${rootClassName} ${prevClassName}` : prevClassName;
};
export const AppContext = /*#__PURE__*/createContext({
  theme: 'external'
});
export const AppProviderContext = ({
  children,
  theme
}) => {
  configureRootTheme({
    theme: presets[theme]
  });
  return /*#__PURE__*/React.createElement(AppContext.Provider, {
    value: {
      theme
    }
  }, children);
};